// import * as XLSX from "xlsx";
import * as XLSX from "xlsx-js-style";

const SHEET_NAME = "Products";
const FILENAME = "product_upload_format.xlsx";

// Outer UOM Qty, Manufacturing Date, Expiry Date, Location removed from Product Master
const TEMPLATE_HEADERS = [
  "Customer SKU Code",
  "SKU Name",
  // "Description",
  // "Product Name",
  // "Company",
  "Customer Name",
  "Base Price",
  "Unit of Measure (UOM)", // Outer UOM
  // "Outer UOM Qty",
  // "Inner UOM",
  // "Inner UOM Qty",
  // "Pallet UOM",
  "UOM Qty Per Pallet",
  // "Cases Per Pallet",
  "Conversion Qty Per Pallet",
  "Gross Weight as per Pallet UOM (kg)",
  "Supplier Name",
  "SKU Category",
  // "Manufacturing Date",
  // "Expiry Date",
  "Shelf Life (Days)",
  // "Location",
  "Length (cm)",
  "Breadth (cm)",
  "Height (cm)",
  "Batch Controlled",
  "Storage Type",
  "Product Type",
];

// Helper row (parser should skip this row)
const INSTRUCTIONS_ROW = [
  "Optional. Leave blank to auto-generate",
  "Required. Product name",
  // "Required. Short description/name",
  // "Required. Product name",
  "Optional. Company name(s), comma separated",
  "Optional. Number >= 0",
 "Required. Select outer UOM (PCS / KG / L / PACK / CASE / DRUM / BAG)",
  // "Optional. Number >= 0", // Outer UOM Qty removed
  // "Optional. Select inner UOM (only after selecting Outer UOM; not allowed when Outer UOM is PCS)",
  // "Optional. Number >= 0; use only when inner UOM is selected",
  // "Optional. Select pallet UOM",
  "Optional. Number > 0 when pallet conversion is used",
  // "Optional. Integer >= 1", // Cases Per Pallet
  "Required. Number greater than 0",
  "Required. Gross weight as per Pallet UOM in kg",
  "Optional. Supplier name",
  "Optional. CORE or NON_CORE",
  // "Optional. Date (YYYY-MM-DD)", // Manufacturing Date removed
  // "Optional. Date (YYYY-MM-DD)", // Expiry Date removed
  "Optional. Integer >= 0",
  // "Optional. e.g. Warehouse A", // Location removed
  "Required. Number >= 0",
  "Required. Number >= 0",
  "Required. Number >= 0",
  "Optional. YES or NO",
  "Required. FROZEN / CHILLED / TROPICAL / DRIED",
  "Required. FOOD / NON FOOD / CHEMICAL",
];

const SAMPLE_ROW_1 = [
  "SKU-001",
  "SKU Name Example",
  // "Short description example",
  // "SKU Name Example",
  "Company A, Company B",
  999.99,
  "CASE",
  // 12, // Outer UOM Qty removed
  // "PCS",
  // 1,
  // "CASE",
  24,
  // 40, // Cases Per Pallet
  24,
  1.2,
  "ABC Supplier",
  "NON_CORE",
  // "2026-02-01", // Manufacturing Date removed
  // "2026-08-01", // Expiry Date removed
  180,
  // "Warehouse A", // Location removed
  10,
  5,
  3,
  "YES",
  "TROPICAL",
  "FOOD",
];
export function downloadProductUploadTemplate() {
  const wsData = [TEMPLATE_HEADERS, INSTRUCTIONS_ROW, SAMPLE_ROW_1];

  const ws = XLSX.utils.aoa_to_sheet(wsData);
  // Make header row bold
TEMPLATE_HEADERS.forEach((_, colIndex) => {
 const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex }); // row 0 = header
 if (ws[cellAddress]) {
   ws[cellAddress].s = {
     font: { bold: true },
   };
 }
});

  // ✅ Column widths for readability (Outer UOM Qty, MFG Date, EXP Date, Location removed)
  ws["!cols"] = [
    { wch: 18 }, // SKU Code
    { wch: 28 }, // SKU Name
    // { wch: 28 }, // Description
    // { wch: 28 }, // Product Name
    { wch: 26 }, // Company
    { wch: 14 }, // Base Price
    { wch: 20 }, // Outer UOM
    // { wch: 18 }, // Inner UOM
    // { wch: 14 }, // Inner UOM Qty
    // { wch: 16 }, // Pallet UOM
    { wch: 22 }, // UOM Qty Per Pallet
    // { wch: 18 }, // Cases Per Pallet
    { wch: 18 }, // Conversion Qty Per Pallet
    { wch: 14 }, // Weight
    { wch: 22 }, // Supplier
    { wch: 14 }, // SKU Category
    { wch: 18 }, // Shelf Life (Days)
    { wch: 14 }, // Length
    { wch: 14 }, // Breadth
    { wch: 14 }, // Height
    { wch: 18 }, // Batch Controlled
    { wch: 18 }, // Storage Type
    { wch: 18 }, // Product Type
  ];

  // ✅ Make header row bold (best-effort; some XLSX builds may ignore styles)
  for (let c = 0; c < TEMPLATE_HEADERS.length; c++) {
    const addr = XLSX.utils.encode_cell({ r: 0, c });
    if (!ws[addr]) continue;
    ws[addr].s = {
      ...(ws[addr].s || {}),
      font: { ...((ws[addr].s || {}).font || {}), bold: true },
    };
  }

  // ✅ Data validation dropdowns
  const startRow = 3;
  const endRow = 5000;

  ws["!dataValidation"] = [
   // Outer UOM → Column E
   {
     type: "list",
     allowBlank: 1,
     sqref: `E${startRow}:E${endRow}`,
     formulas: ['"Select Outer UOM,PCS,KG,L,PACK,CASE,DRUM,BAG"'],
   },
 
   // Inner UOM → Column F
   // {
   //   type: "list",
   //   allowBlank: 1,
   //   sqref: `F${startRow}:F${endRow}`,
   //   formulas: ['"Select Inner UOM,PCS,KG,L,PACK,CASE,DRUM,BAG"'],
   // },
 
   // Pallet UOM → Column H
   // {
   //   type: "list",
   //   allowBlank: 1,
   //   sqref: `H${startRow}:H${endRow}`,
   //   formulas: ['"Select Pallet UOM,PCS,KG,L,PACK,CASE,DRUM,BAG"'],
   // },
 
   // SKU Category → Column M
   {
     type: "list",
     allowBlank: 1,
     sqref: `M${startRow}:M${endRow}`,
     formulas: ['"CORE,NON_CORE"'],
   },
 
   // Batch Controlled → Column R
   {
     type: "list",
     allowBlank: 1,
     sqref: `R${startRow}:R${endRow}`,
     formulas: ['"YES,NO"'],
   },
 
   // Storage Type → Column S
   {
     type: "list",
     allowBlank: 1,
     sqref: `S${startRow}:S${endRow}`,
     formulas: ['"FROZEN,CHILLED,TROPICAL,DRIED"'],
   },
 
   // Product Type → Column T
   {
     type: "list",
     allowBlank: 1,
     sqref: `T${startRow}:T${endRow}`,
     formulas: ['"FOOD,NON FOOD,CHEMICAL"'],
   },
 ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, SHEET_NAME);

  const wbout = XLSX.write(wb, {
   bookType: "xlsx",
   type: "array",
   cellStyles: true,
 });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
